import { nanoid } from 'nanoid';
import { useRef } from 'react';

type SegmentedControlProps = {
	options: { label: string; value: string }[];
	value: string;
	onChange: (value: string) => void;
	testIdPrefix?: string;
	description?: string;
	name?: string;
};

export default function SegmentedControl({ options, value, onChange, testIdPrefix = '', description, name }: SegmentedControlProps) {
	const generatedNameRef = useRef(nanoid());
	const groupName = `segctrl-${name || generatedNameRef.current}`;
	const selectedIndex = Math.max(
		options.findIndex((option) => option.value === value),
		0,
	);

	const styleProperties: React.CSSProperties = {
		'--items': options.length.toString(),
		'--index': selectedIndex.toString(),
	} as React.CSSProperties;

	return (
		<fieldset className="segmented-control" style={styleProperties}>
			{description && <legend className="segmented-control__legend">{description}</legend>}
			{options.map((option) => {
				const isSelected = value === option.value;

				return (
					<label key={option.value} className={isSelected ? 'selected' : ''}>
						<input
							type="radio"
							name={groupName}
							value={option.value}
							checked={isSelected}
							data-testid={`${testIdPrefix}segctrl-option-${option.value}`}
							onChange={() => onChange(option.value)}
						/>
						{option.label}
					</label>
				);
			})}
		</fieldset>
	);
}
